import Vue from 'vue';

export class Texts {
    constructor(language = "nl") {
        const storedLang = localStorage.getItem("language");
        this.state = Vue.observable({
            language: storedLang || language,
        });
    }

    getText(key) {
        const lang = this.state.language;
        switch (lang) {
            case "en":
                return this.english()[key] || key;
            case "nl":
                return this.dutch()[key] || key;
            default:
                return this.english()[key] || key;
        }
    }

    english() {
        return {
            Aanpassen:"adjust",
            AanpassenWaarneming:"Adjust observation",
            AanpassenGegevensWaarnemer:"Adjust data observer",
            AanpassenWaarnemingenWaarnemer:"adjust observations observer",
            AantalGrafiekSchaalDag:"Label per day",
            AantalGrafiekSchaalMaand:"Label per month",
            AantalPenumbra:"Number of penumbrae in group",
            AantalUmbra:"Umbrae other",
            AantalUmbraInPenumbra:"Number of umbrae in penumbrae",
            AantalTekensWachtwoord:"Length password",
            AantalWaarnemers:"Number of observers: ",
            achtKarakter1:"At least",
            achtKarakter2:"characters",
            admin:"admin",
            adminEmail:"Admin email",
            Afbeelding:"Image",
            Afgeglad:"Smoothed averages",
            AlInGebruik:" is already in use",
            alleObs:"All observations",
            AlleWaarnemers:"Observations of all observers",
            Andere:"Other",
            Annuleren:"CANCEL",
            Beck:"Beck number R'",
            BeckSelectieKnop:"Input Beck",
            BeginDatum: "Start date",
            Bericht: "Message",
            BestaandeTelescopen:"Existing telescopes",
            Bestand:"File",
            Beste:"Dear",
            Bevestig:'confirm',
            BevestigingVerplicht:"Confirmation is mandatory",
            BewerkWaarnemingen:"edit observations",
            BezigUpload:"File uploading...",
            BloteOogGroepen: "Naked eye groups: ",
            BloteOogWaarnemen:"Only naked eye observation",
            BloteOogWaarneming:"Naked eye observation of",
            BoodschapMail:"Message",
            BoodschapVerplicht:"Message is required",
            Calcium:"Calcium",
            Catadioptrisch:"Catadioptric",
            CorrectieMogelijk:"Earliest date correction observations",
            CV:"McIntosch CV number",
            CVSelectieKnop:"Input CV",
            CVPenumbraKlasseX:"x: no penumbra",
            CVPenumbraKlasseR:"r: rudimentary penumbra",
            CVPenumbraKlasseS:"s: small elliptical penumbra",
            CVPenumbraKlasseA:"a: small irregular penumbra",
            CVPenumbraKlasseH:"h: large elliptical penumbra",
            CVPenumbraKlasseK:"k: large irregular penumbra",
            CVVerdelingKlasseX:"x: unipolar group",
            CVVerdelingKlasseO:"o: bipolar group without spots between the main spots",
            CVVerdelingKlasseI:"i: bipolar group with spots without penumbra between the main spots",
            CVVerdelingKlasseC:"c: bipolar group with spots with penumbra between the main spots",
            DagelijkseGemiddelden:"Daily averages",
            DagenZonderInlog:"Days without logging in",
            DataGewijzigd:"Data has been changed",
            Datum:"Date",
            DatumInvullen:"Date must be entered",
            DatumNaBegin:"Date must be after start date",
            Diameter:"Diameter",
            Doorgaan:"Continue",
            DownloadExcel:"Download your observations",
            EindDatum: "End date",
            email:"email",
            emailNodigCorrect:"E-mail must be valid",
            Engels:"English",
            ErGingIetsMis:"Something went wrong",
            ExcelOpmerking:"Please note, your set telescope and observing method will be used",
            excelWaarnemer:"Download observations",
            ExpertSelectieKnop:"Input SN/IS",
            fakkelnoord:"North",
            Fakkels:"Polar faculae",
            FH1:"Faculae are lighter areas on the sun. These often occur in groups of spots and are more visible near the edge. They are often bright string-shaped structures. An area with faculae is called a faculae field. The VVS working group has no program to follow these.",
            FakkelsHulpInleiding:"Near the poles of the Sun, the so-called polar faculae can be found. These are bright point-shaped spots. These are followed by the VVS working group Sun.\n" +
                "The number of polar faculae follows the cycle of the Sun. However, their maximum usually falls near the minimum of the spot cycle.\n",
            FH2:"Determining the polar faculae is easy. We distinguish the faculae near the northern and southern poles:\n" +
                "PF (north or south) = number of polar faculae\n" +
                "TF total = PF north + P south",
            FHT1:"Faculae",
            FHT2:"Polar faculae",
            fakkeltotaal:"Total",
            FakkelWaarnemen:"Observations polar faculae",
            fakkelzuid:"South",
            folderDownloads:"is in your Downloads folder",
            FotoZon:"Original image sun",
            FotosZon:"Images sun: ",
            Fout:"ERROR",
            FoutEmail:"is incorrect or not registered",
            FoutInlog:"An error occurred while logging in",
            FoutOpmaakBeck:"Error in Beck group formatting. Required formatting: ",
            FoutOpmaakCijfers: "You wanted to upload Waldmeier or CV classification instead of numbers",
            FoutOpmaakCV:"Error in CV group formatting. Required formatting: ",
            FoutWachtwoord:"Password is not correct",
            gast:"guest",
            GeenLid:"no member",
            GeenVlekken:"No spots present",
            GeenWaarnemingen:"No observations in the selected period",
            GeenWaarnemingenMaand:"No observations in this month",
            GegevensVan:"Data of ",
            GegevensVanTelescoop:"Data telescope",
            GegevensVanWaarnemer:"Data observer",
            GlasFilter:"Glass filter",
            GenereerMaandrapport:"Generate monthly report",
            genereerWachtwoord:"Generate a password",
            Grafiek:"Graph",
            GrafiekBeck:"Beck number observations",
            GrafiekCV:"Observations McIntosch CV",
            GrafiekPoolfakkel:"Observations polar faculae",
            GrafiekWolf:"Observations Wolf number",
            GroepMinVlek:"A group has at least 1 spot",
            GroepVlekVerplicht:"Groups and spots are required",
            Halpha:"H-alpha",
            HerschelWig:"Herschel wedge",
            HulpIdentHalfrond:"Help for identifying hemispheres of the sun",
            HulpTelescoopmodel:"Help for telescope models",
            HulpVlekken:"Help for identifying groups and spots",
            HulpPoolfakkels:"Help with polar faculae",
            HulpQfactor:"Help for quality Q",
            Instellingen:"Admin",
            InstellingenApp:"Settings app",
            InterSolar:"Inter Solar number",
            InvoerenWaarneming:"Add observation",
            IS:"Paderborn IS number",
            Kwaliteit:"Quality",
            KwaliteitVerplicht:"The quality of the observation is mandatory",
            LaatsteMaandrapport:"Latest monthly report: ",
            lid:"member",
            Lidnummer:"VVS membership number",
            Lijst:"list",
            LocaleTijd: "Local time",
            Maandgemiddelde:"Monthly average R: ",
            MaandgemiddeldeVan:"Monthly average of: ",
            maandOverzicht:"Month Reports",
            Maandrapport:"Create report",
            MaandSelect:'select month',
            MaandSelectDownload:"select month download",
            McIntoschKlasse:"McIntosch classification",
            MailLijn:"VVS WG ZON\nObservation app",
            Methode:"Method",
            MinimaalEen:"Minimum 1",
            MinimaalNul:"Minimum o",
            MinimaalPenumbra:"minimum number of penumbrae: ",
            MinimaalVlekken:"minimum number of spots: ",
            MinimaalWaarnemingen:"Minimum number of observations to show graph: ",
            MinimaalWaarnemingen2:"observations needed in the selection to show a graph!",
            MinimumGrafiek:"Obs needs for graph",
            Minuut: "m",
            MinuutInvoerNummer:"Minutes must be between 0 and 59",
            MinuutInvoerVerplicht:"Minutes are required",
            Naam:"Name",
            Nederlands:"Dutch",
            NetwerkProbleem:"Network problem, please try again later",
            Noord:"North",
            obsBetweenDates:"Observations between dates",
            obsMaand:"Observations of month",
            OnderwerpVerplicht:"Subject is required",
            Openingsverhouding:"Ratio f/",
            Opgelet:"Attention",
            Opladen:"Uploading",
            OpslaanParams:"Save changes",
            OverschrijvenData:"Please note, existing data from groups and spots will be overwritten",
            Overzichten: "Overview",
            Overzicht:"Overview",
            overzichtWaarnemers:"Overview of observers",
            Parameters:"Customizable application settings",
            PenumbraGrootste:"Penumbra largest spot",
            PersoonlijkeGegevens:"Personal data",
            Pettis:"Pettis SN value",
            PolymeerFilter:"Polymer filter",
            ProjectieScherm:"Projection screen",
            Poolfakkels:"Arctic flares",
            Q0:"0: worthless",
            Q0help:"Worthless observation (incomplete, blurred image,...)",
            Q1:"1: no penumbra",
            Q1help:"Only the large spots are visible, penumbrae not visible",
            Q2:"2: penumbra",
            Q2help:"Only the large spots are visible, both umbra and penumbra are visible",
            Q3:"3: small spots",
            Q3help:"Smaller spots visible, shape of penumbra is clearly visible. Large flares are also visible",
            Q4:"4: smallest spots",
            Q4help:"Very small spots and flares are visible. Granulation is quite visible",
            Q5:"5: perfect",
            Q5help:"Near perfect image, granulation is visible over the entire disk. Fine structures in the penumbra are clearly visible",
            Rapporten:"Reports",
            RapportAangemaakt:"Report created",
            RapportMaken:"Create report",
            Reflector:"Reflector",
            Refractor:"Refractor",
            Registreer:"If you are a new observer, register here",
            RegistratieSucces:"You are registered and can now log in",
            SchaalGrafiek:"Units scale chart",
            selecteerPeriode:"Select period",
            selecteerWaarneming:"Select observation",
            SelectieBoodschap:"Previous values for sunspot groups will be deleted",
            selectieGrootteGklasse:"Select the size of the group",
            sluiten:"Close",
            SN:"Pettis SN number",
            Status:"status",
            StelWachtwoordIn:"Or enter a password",
            T0Alg:"The model of the telescope is independent of the use of accessories on the eyepiece side.",
            T1Refr: "A refractor is a telescope that only contains lenses as an objective. In addition, there are intermediate lenses to lengthen or shorten the point of reference of the extended.",
            T2Refl:"A reflector is a telescope that uses only mirrors. In addition to the objective, there may be one or more secondary mirrors. The textbook example is the Newton telescope. This includes the Kutter telescope, the Ritchey-Chrétien telescope and the Cassegrain telescope (without Schmidt corrector).",
            T3Cat:"A catadioptric telescope uses a combination of mirrors and lenses to collect light. The example model is the Schmidt-Cassegrain telescope. All other telescopes that are standard under the other models belong to this group if a combination of mirrors and lenses is used. Some examples: the trestle refractor, Newton with a correcting plate in front.",
            Telescoop:"Telescope",
            TelescoopGegevens:"Telescope data",
            Telescoopmodel:"Telescope type",
            Tijd:"Time",
            TitelMail:"Subject",
            TitelsMenu:"Menu titles",
            ToonWaarnemingen:"Show observations",
            Totaal:"Total",
            TotAantalPenumbra:"The total number of penumbrae in the group",
            TotAantalUmbraNietInPenumbra:"The total number of umbrae in the group that are not in a penumbra",
            TotAantalUmbraInPenumbra:"The total number of umbrae in the group that are in the penumbrae",
            Type:"Type",
            Uitloggen:"Log out",
            Uploaden: "Uploaden",
            UT:"Universal time (UT)",
            Uur:"h",
            UurInvoerNummer:"Hour must be between 0 and 23",
            UurInvoerVerplicht:"Hour is required",
            VeldVerplicht:"THis field is mandatory",
            Verdeling:"Distribution ",
            VerdelingVlekken:"Sunspot distribution in group",
            vergroting:"Magnification",
            VergrotingVerplicht:"Magnification is required",
            VerplichtCijfersFormulier:"Only values allowed for Beck number and CV number",
            VerplichtKlasseForm:"Mandatory format Beck: A1;B6;... or A1 Mandatory format CV: Axx(A1);Bx0(B6);... or Axx(A1)",
            Versie:"Version",
            Verwijderen:"Delete",
            VerwijderMaand:"Remove all observations of month:",
            Verzenden:"Send",
            Vlag:"flag",
            Vlekken:"Spots",
            VlekIdentificatie:"Spots and groups",
            VoerBrandpuntIn:"Input focal length",
            VoerOpeningsverhoudingIn:"Input focal ratio",
            Voornaam:"First name",
            VriendelijkeGroeten:"Kind regards",
            VVS:"VVS",
            WaarneemMethoden:"Observing methods",
            waarnemer:"Observer",
            Waarnemers:"Observers: ",
            WaarnemersLijst:"Observers",
            WaarnemingenAndereWaarnemer:"Select observer",
            Waarnemingen: "Observations",
            waarnemingen:"observations",
            WaarnemingenVan:"Observations of",
            WaarnemingenExcel:"Upload observation",
            WaarnemingToevoegen:"Add observation",
            WaarnemingToegevoegd:"Added observations",
            WaarnemingNIetToevoegen:"Unable to add observations",
            WaarnemingAlInMaand:"There is already an observation present in this period",
            WaarnemingToevoegSucces:"The observations were successfully added",
            WaarnemingenVanMaandUpload:"Upload Excel with observations of a month",
            WaarnemingenVanMaandUploadInfo:"Excel structure with description of groups",
            WaarnemingenVanMaandUploadInfoCijfers:"Structure Excel with value groups",
            WaarnemingVerwijderenBoodschap:"Are you sure you want to delete this observation?",
            WaarnemingenMaandVerwijderen:"Are you sure you want to delete all observations for this month: ",
            Wachtwoord:"password",
            WachtwoordIncorrect:"Wrong password",
            WachtwoordNietOvereen:"Passwords dont mach",
            WachtwoordVerplicht:"Password is mandatory",
            WachtwoordWijzig:"Password has been changed",
            WaldmeierKlasse:"Waldmeier class",
            WaldmeierKlasseA: "A: unipolar spot or group of spots without penumbra",
            WaldmeierKlasseB:"B: bipolar spot group without penumbra",
            WaldmeierKlasseC:"C: bipolar group with penumbra in one of the two parts but not in both",
            WaldmeierKlasseD:"D: bipolar group with penumbrae in both parts",
            WaldmeierKlasseE:"E: large bipolar group with penumbra in both parts and a complex structure. At least 10° in the longitudinal direction",
            WaldmeierKlasseF:"F: very large bipolar and complex group. At least 15° in the longitudinal direction",
            WaldmeierKlasseG:"G: large bipolar group without small spots between the main spots. At least 10° in the longitudinal direction",
            WaldmeierKlasseGE:"G(E): large bipolar group without small spots between the main spots. At least 10° in length, but less than 15°",
            WaldmeierKlasseGF:"G(F): very large bipolar group without small spots between the main spots. At least 15° in the longitudinal direction",
            WaldmeierKlasseH:"H: single spot or unipolar group with penumbra. Group is larger than 2.5°",
            WaldmeierKlasseJ:"J: single spot or unipolar group with penumbra. Group is smaller than 2.5°",
            WijzigGegevens:"SAVE",
            WijzigWachtwoord:"Change password",
            WitLicht:"White light",
            Wolfgetal: "Wolf number",
            WolfHulpInleiding:"Spot groups on the sun occur in two types of groups: unipolar and bipolar. In a group, dark umbrae or spots occur with possibly also the lighter penumbrae.",
            WolfgetalSelectieKnop:"Input Wolf",
            WH1:"To determine the activity, the number of groups and the number of umbrae within that group must be counted. \n" +
                "g = groups (N = northern hemisphere sun, S = southern hemisphere)\n" +
                "f = spots in the groups (N = northern hemisphere sun, S = southern hemisphere)\n" +
                "r = activity number or Wolf number = 10*g + f (N = northern hemisphere sun, S = southern hemisphere)\n",
            WH2:"Unipolar groups are small groups without bipolar structure. Penumbrae can also occur in unipolar groups. For a unipolar group, g = 1 and f = number of umbrae in that group. A single spot counts as a group and a spot!",
            WH3:"Bipolaire groepen vertonen twee delen net als de polen van een magneet (wat ook zo is). Voor een bipolaire groep telt g= 1 en f = aantal umbrae in die groep.",
            WH4:"g = 1, f = 1",
            WH5:"g = 1, f = 4",
            WH6:"g = 1, f = 7",
            WH7:"g = 1, f = 11",
            WH8:"g = 1, f = 128",
            WHT1:"Activity of the Sun",
            WHT2:"Unipolar group",
            WHT3:"Bipolar groups",
            WHT4:"Example of a single spot without penumbrae",
            WHT5:"Example of a single spot with penumbrae",
            WHT6:"Example of bipolar group without penumbrae",
            WHT7:"Example of bipolar group with penumbrae",
            WHT8:"Example of very large bipolar group (Photo: NASA)",
            WolfNoord:"Wolf number north Rn",
            WolfTotaal:"Wolf number R",
            WolfgetalVan:"Wolf number of ",
            WolfZuid:"Wolf number south Rn",
            Zuid:"South",
            greeting: "Hello",
        };
    }

    dutch() {
        return {
            Aanpassen:"aanpassen",
            AanpassenWaarneming:"Aanpassen waarneming",
            AanpassenGegevensWaarnemer:"Aanpassen gegevens waarnemer",
            AanpassenWaarnemingenWaarnemer:"Aanpassen waarnemingen waarnemer",
            AantalGrafiekSchaalDag:"Label per dag",
            AantalGrafiekSchaalMaand:"Label per maand",
            AantalPenumbra:"Aantal penumbrae in groep",
            AantalUmbra:"Umbrae andere",
            AantalUmbraInPenumbra:"Aantal umbrae in penumbrae",
            AantalTekensWachtwoord:"Lengte wachtwoord",
            AantalWaarnemers:"Aantal waarnemers: ",
            achtKarakter1:"Minstens",
            achtKarakter2:"karakters",
            admin:"admin",
            adminEmail:"Admin email",
            Afbeelding:"Afbeelding",
            Afgeglad:"Afgegladde gemiddelden",
            alleObs:"Alle waarnemingen",
            AlleWaarnemers:"Waarnemingen van alle waarnemers",
            AlInGebruik:" is al in gebruik",
            Andere:"Andere",
            Annuleren:"ANNULEREN",
            Beck:"Beck getal R'",
            BeckSelectieKnop:"Invoer Beck",
            BeginDatum: "Begin datum",
            Bericht: "Bericht",
            BestaandeTelescopen:"Bestaande telescopen",
            Bestand:"Bestand",
            Beste:"Beste",
            Bevestig:'bevestig',
            BevestigingVerplicht:"Bevestiging is verplicht",
            BewerkWaarnemingen:"bewerken waarnemingen",
            BezigUpload:"Bezig met uploaden...",
            BloteOogGroepen: "Blote oog groepen: ",
            BloteOogWaarnemen:"Enkel blote oog waarneming",
            BloteOogWaarneming:"Blote oog waarneming van",
            BoodschapMail:"Bericht",
            BoodschapVerplicht:"Boodschap is verplicht",
            Brandpunt:"Brandpunt",
            Calcium:"Calcium",
            Catadioptrisch:"Catadioptrisch",
            CorrectieMogelijk:"Vroegste datum correctie waarnemingen",
            CV:"McIntosch CV waarde",
            CVSelectieKnop:"Invoer CV",
            CVPenumbraKlasseX:"x: geen penumbra",
            CVPenumbraKlasseR:"r: rudimentaire penumbra",
            CVPenumbraKlasseS:"s: kleine ellipsvormige penumbra",
            CVPenumbraKlasseA:"a: kleine onregelmatige penumbra",
            CVPenumbraKlasseH:"h: grote ellipsvormige penumbra",
            CVPenumbraKlasseK:"k: grote onregelmatige penumbra",
            CVVerdelingKlasseX:"x: unipolaire groep",
            CVVerdelingKlasseO:"o: bipolaire groep zonder vlekken tussen de hoofdvlekken",
            CVVerdelingKlasseI:"i: bipolaire groep met vlekken zonder penumbra tussen de hoofdvlekken",
            CVVerdelingKlasseC:"c: bipolaire groep met vlekken met penumbra tussen de hoofdvlekken",
            DagelijkseGemiddelden:"Dagelijkse gemiddelden",
            DagenZonderInlog:"Dagen zonder inloggen",
            DataGewijzigd:"Gegevens zijn gewijzigd",
            Datum:"Datum",
            DatumInvullen:"Datum moet ingevuld worden",
            DatumNaBegin:"Datum moet na begindatum vallen",
            Diameter:"Diameter",
            Doorgaan:"Doorgaan",
            DownloadExcel:"Download je waarnemingen",
            EindDatum: "Eind datum",
            email:"email",
            emailNodigCorrect:"E-mail moet juiste structuur bezitten",
            Engels:"Engels",
            ErGingIetsMis:"Er ging iets mis",
            ExcelOpmerking:"Opgelet, je ingestelde telescoop en waarneemmethode wordt gebruikt",
            excelWaarnemer:"Waarnemingen downloaden",
            ExpertSelectieKnop:"Invoer SN/IS",
            fakkelnoord:"Noord",
            fakkeltotaal:"Totaal",
            Fakkels:"Poolfakkels",
            FH1:"Fakkels zijn lichtere gebieden op de zon. Deze komen vaak voor bij vlekkengroepen en zijn duidelijker te zien nabij de rand. Vaak gaat het om heldere sliertvormige structuren. Een gebied met fakkels noemen we een fakkelveld. De VVS werkgroep heeft geen programma om deze op te volgen",
            FakkelsHulpInleiding:"Nabij de polen van de Zon zijn de zogenaamde poolfakkels terug te vinden. Het gaat om heldere puntvormige vlekken. Deze worden wel gevolgd door de VVS werkgroep Zon.\n" +
                "Het aantal poolfakkels volgt de cyclus van de Zon. Wel valt hun maximum gewoonlijk nabij het minimum van de vlekkencyclus\n",
            FH2:"Bepaling van de poolfakkels is eenvoudig. We onderscheiden de fakkels nabij de noordelijke en de zuidelijke pool:\n" +
                "PF (noord of zuid) = aantal poolfakkels\n" +
                "TF totaal = PF noord + P zuid",
            FHT1:"Fakkels",
            FHT2:"Poolfakkels",
            FakkelWaarnemen:"Waarnemingen poolfakkels",
            fakkelzuid:"Zuid",
            folderDownloads:"staat in je folder Downloads",
            FotoZon:"Originele foto zon",
            FotosZon:"Foto's zon: ",
            Fout:"FOUT",
            FoutEmail:"is fout of niet geregistreerd",
            FoutInlog:"Er is een fout opgetreden tijdens het inloggen",
            FoutOpmaakBeck:"Fout in opmaak Beck groepen. Verplichte opmaak: ",
            FoutOpmaakCijfers: "Je hebt Waldmeier of CV classificatie willen opladen in plaats van cijfers",
            FoutOpmaakCV:"Fout in opmaak CV groepen. Verplichte opmaak: ",
            FoutWachtwoord:"Wachtwoord is niet correct",
            gast:"gast",
            GeenLid:"geen lid",
            GeenVlekken:"Geen vlekken aanwezig",
            GeenWaarnemingen:"Geen waarnemingen in de geselecteerde periode",
            GeenWaarnemingenMaand:"Geen waarnemingen in deze maand",
            GegevensVan:"Gegevens van ",
            GegevensVanTelescoop:"Gegevens telescoop",
            GegevensVanWaarnemer:"Gegevens waarnemer",
            GlasFilter:"Glas filter",
            GenereerMaandrapport:"Genereer maandrapport",
            genereerWachtwoord:"Genereer een wachtwoord",
            Grafiek:"Grafiek",
            GrafiekBeck:"Waarnemingen Beckgetal",
            GrafiekCV:"Waarnemingen McIntosch CV",
            GrafiekPoolfakkel:"Waarnemingen poolfakkels",
            GrafiekWolf:"Waarnemingen Wolfgetal",
            GroepMinVlek:"Een groep heeft minimaal 1 vlek",
            GroepVlekVerplicht:"Groepen en vlekken zijn verplicht",
            Halpha:"H-alpha",
            HerschelWig:"Herschel wig",
            HulpIdentHalfrond:"Hulp bij identificeren halfronden zon",
            HulpTelescoopmodel:"Hulp voor telescoopmodellen",
            HulpVlekken:"Hulp voor identificeren groepen en vlekken",
            HulpPoolfakkels:"Hulp bij poolfakkels",
            HulpQfactor:"Hulp voor kwaliteit Q",
            Instellingen:"Admin",
            InstellingenApp:"Instellingen app",
            InterSolar:"Inter Solar waarde",
            InvoerenWaarneming:"Toevoegen waarneming",
            IS:"Paderborn IS waarde",
            Kwaliteit:"Kwaliteit",
            KwaliteitVerplicht:"De kwaliteit van de waarneming is verplicht",
            LaatsteMaandrapport:"Laatste maandrapport: ",
            lid:"lid",
            Lidnummer:"VVS lidnummer",
            Lijst:"lijst",
            LocaleTijd: "Locale tijd",
            Maandgemiddelde:"Maandgemiddelde R: ",
            MaandgemiddeldeVan:"Maandgemiddelde van: ",
            maandOverzicht:"Maand Rapporten",
            MaandSelect:"selecteer maand",
            MaandSelectDownload:"selecteer maand download",
            Maandrapport:"Maandrapport",
            McIntoschKlasse:"McIntosch classificatie",
            MailLijn:"VVS WG ZON\nWaarneem app",
            Methode:"Methode",
            MinimaalEen:"Minimaal 1",
            MinimaalNul:"Minimaal o",
            MinimaalPenumbra:"minimaal aantal penumbrae: ",
            MinimaalVlekken:"minimaal aantal vlekken: ",
            MinimaalWaarnemingen:"Minimaal aantal waarnemingen om grafiek te tonen: ",
            MinimaalWaarnemingen2:"waarnemingen hebben in de selectie om een grafiek te tonen!",
            MinimumGrafiek:"Grafiek vanaf",
            Minuut: "m",
            MinuutInvoerNummer:"Minuten moet tussen 0 en 59 liggen",
            MinuutInvoerVerplicht:"Minuten zijn verplicht",
            Naam:"Naam",
            Nederlands:"Nederlands",
            NetwerkProbleem:"Probleem met het netwerk, probeer het later nog eens",
            Noord:"Noord",
            obsBetweenDates:"Waarnemingen tussen datums",
            obsMaand:"Waarnemingen van maand",
            OnderwerpVerplicht:"Onderwerp is verplicht",
            Openingsverhouding:"Openingsverhouding f/",
            Opgelet:"Opgelet",
            Opladen:"Opladen",
            OpslaanParams:"Wijzigingen opslaan",
            OverschrijvenData:"Opgelet, aanwezige data van groepen en vlekken wordt overschreven",
            Overzicht:"Overzicht",
            Overzichten:"Overzichten",
            overzichtWaarnemers:"Overzicht waarnemers",
            Parameters:"Aanpasbare instellingen app",
            PenumbraGrootste:"Penumbra grootste vlek",
            PersoonlijkeGegevens:"Persoonlijke gegevens",
            Pettis:"Pettis SN waarde",
            PolymeerFilter:"Polymeer filter",
            ProjectieScherm:"Projectie scherm",
            Poolfakkels:"Poolfakkels",
            Q0:"0: waardeloos",
            Q0help:"Waardeloze waarneming (incompleet, onscherp beeld,...)",
            Q1:"1: geen penumbra",
            Q1help:"Alleen de grote vlekken zijn zichtbaar, penumbrae niet zichtbaar",
            Q2:"2: penumbra",
            Q2help:"Alleen de grote vlekken zijn zichtbaar, zowel umbra als penumbra zichtbaar",
            Q3:"3: kleine vlekken",
            Q3help:"Kleinere vlekken zichtbaar, de vorm van de penumbra is goed zichtbaar. Grote fakkels zijn eveneneens zichtbaar",
            Q4:"4: kleinste vlekken",
            Q4help:"Zeer kleine vlekken en fakkels zijn zichtbaar. Granulatie is vrij goed te zien",
            Q5:"5: perfect",
            Q5help:"Vrijwel perfect beeld, granulatie is over de volledige schijf zichtbaar. Fijne structuren in de penumbra goed zichtbaar",
            Rapporten:"Rapporten",
            RapportAangemaakt:"Rapport aangemaakt",
            RapportMaken:"Maak rapport",
            Reflector:"Reflector",
            Refractor:"Refractor",
            Registreer:"Ben je een nieuwe waarnemer, registreer hier",
            RegistratieSucces:"Je bent geregistreerd en kan nu inloggen",
            SchaalGrafiek:"Eenheden schaal grafiek",
            selecteerPeriode:"Selecteer periode",
            selecteerWaarneming:"Selecteer waarneming",
            SelectieBoodschap:"Voorgaande waarden voor vlekken groepen worden verwijderd",
            selectieGrootteGklasse:"Selecteer de grootte van de groep",
            sluiten:"Sluiten",
            SN:"Pettis SN waarde",
            Status:"status",
            StelWachtwoordIn:"Of geef een wachtwoord op",
            T0Alg:"Het model van de telescoop is onafhankelijk van het gebruik van toebehoren aan oculairzijde.",
            T1Refr:"Een refractor is een telescoop die enkel lenzen bevat als objectief. Eventueel zijn er nog tussenliggende lenzen aangebracht om het brandpunt van het objectief te verlengen of te verkorten.",
            T2Refl:"Een reflector is een telescoop die enkel spiegels gebruikt. Naast het objectief is er eventueel nog een of meerdere vangspiegels aanwezig. Het schoolvoorbeeld is de Newton-telescoop. Hiertoe behoren o.a. de Kutter-telescoop, de Ritchey-Chrétien-telescoop en de Cassegrain-telescoop (zonder Schmidt-corrector).",
            T3Cat:"Een catadioptrische telescoop gebruikt een combinatie van spiegels en lenzen om het licht op te vangen. Het voorbeeldmodel is de Schmidt-Cassegrain-telescoop. Alle andere telescopen die standaard onder de andere modellen vallen, behoren tot deze groep indien er een combinatie van spiegels en lenzen gebruikt wordt. Enkele voorbeelden: de schraagrefractor, Newton met een correctieplaat vooraan.",
            Telescoop:"Telescoop",
            TelescoopGegevens:"Telescoop gegevens",
            Telescoopmodel:"Telescoopmodel",
            Tijd:"Tijd",
            TitelMail:"Onderwerp",
            TitelsMenu:"Titels menu",
            ToonWaarnemingen:"Toon waarnemingen",
            Totaal:"Totaal",
            TotAantalPenumbra:"Het totaal aantal penumbrae in de groep",
            TotAantalUmbraNietInPenumbra:"Het totaal aantal umbrae in de groep die zich niet in een penumbra bevinden",
            TotAantalUmbraInPenumbra:"Het totaal aantal umbrae in de groep die zich in de penumbrae bevinden",
            Type:"Type",
            Uitloggen:"Uitloggen",
            Uploaden:"Uploaden",
            UT:"Wereldtijd (UT)",
            Uur:"h",
            UurInvoerNummer:"Uur moet tussen 0 en 23 liggen",
            UurInvoerVerplicht:"Uur is verplicht",
            VeldVerplicht:"Dit veld moet ingevuld worden",
            Verdeling:"Verdeling",
            VerdelingVlekken:"Verdeling van de zonnevlekken in groep",
            vergroting:"Vergroting",
            VergrotingVerplicht:"Vergroting is verplicht",
            VerplichtCijfersFormulier:"Enkel waarden toegestaan voor Beckgetal en CV-getal",
            VerplichtKlasseForm:"Verplichte opmaak Beck: A1;B6;... of A1 Verplichte opmaak CV: Axx(A1);Bx0(B6);... of Axx(A1)",
            Versie:"Versie",
            Verwijderen:"Verwijderen",
            VerwijderMaand:"Verwijder alle waarnemingen van maand:",
            Verzenden:"Verzend",
            Vlag:"vlag",
            Vlekken:"Vlekken",
            VlekIdentificatie:"Vlekken en groepen",
            VoerBrandpuntIn:"Voer brandpunt in",
            VoerOpeningsverhoudingIn:"Voer openingsverhouding in",
            Voornaam:"Voornaam",
            VriendelijkeGroeten:"Vriendelijke groeten",
            VVS:"VVS",
            WaarneemMethoden:"Waarneem methoden",
            waarnemer: "Waarnemer",
            Waarnemers:"Waarnemers: ",
            WaarnemersLijst:"Waarnemers",
            Waarnemingen: "Waarnemingen",
            waarnemingen:"waarnemingen",
            WaarnemingenVan:"Waarnemingen van",
            WaarnemingenAndereWaarnemer:"Selecteer waarnemer",
            WaarnemingenExcel:"Opladen waarneming",
            WaarnemingToevoegen:"Waarneming toevoegen",
            WaarnemingNIetToevoegen:"Kan waarnemingen niet toevoegen",
            WaarnemingAlInMaand:"Er is al een waarneming aanwezig in deze periode",
            WaarnemingToegevoegd:"Waarnemingen toegevoegd",
            WaarnemingToevoegSucces:"De waarnemingen werden succesvol toegevoegd",
            WaarnemingenVanMaandUpload:"Excel met waarnemingen van een maand uploaden",
            WaarnemingenVanMaandUploadInfo:"Structuur excel met beschrijving groepen",
            WaarnemingenVanMaandUploadInfoCijfers:"Structuur excel met waarden groepen",
            WaarnemingVerwijderenBoodschap:"Ben je zeker dat je deze waarneming wil verwijderen?",
            WaarnemingenMaandVerwijderen:"Ben je zeker dat je alle waarnemingen van deze maand wenst te verwijderen: ",
            Wachtwoord:"wachtwoord",
            WachtwoordIncorrect:"Wachtwoord is fout",
            WachtwoordNietOvereen:"Wachtwoorden komen niet overeen",
            WachtwoordVerplicht:"Wachtwoord is verplicht",
            WachtwoordWijzig:"Wachtwoord is gewijzigd",
            WaldmeierKlasse:"Waldmeier klasse",
            WaldmeierKlasseA: "A: unipolaire vlek of vlekkengroep zonder penumbra",
            WaldmeierKlasseB:"B: bipolaire vlekkengroep zonder penumbra",
            WaldmeierKlasseC:"C: bipolaire groep met penumbra in één van beide delen maar niet in beide",
            WaldmeierKlasseD:"D: bipolaire groep met penumbrae in beide delen",
            WaldmeierKlasseE:"E: grote bipolaire groep met penumbra in beide delen en complexe structuur. Minimaal 10° in lengte richting",
            WaldmeierKlasseF:"F: zeer grote bipolaire en complexe groep. Minimaal 15° in lengterichting",
            WaldmeierKlasseG:"G: grote bipolaire groep zonder kleine vlekken tussen de hoofdvlekken. Minimaal 10° in lengte richting",
            WaldmeierKlasseGE:"G(E): grote bipolaire groep zonder kleine vlekken tussen de hoofdvlekken. Minimaal 10° in lengte richting, maar kleiner dan 15°",
            WaldmeierKlasseGF:"G(F): zeer grote bipolaire groep zonder kleine vlekken tussen de hoofdvlekken. Minimaal 15° in lengte richting",
            WaldmeierKlasseH:"H: enkele vlek of unipolaire groep met penumbrae. Groep is groter dan 2.5°",
            WaldmeierKlasseJ:"J: enkele vlek of unipolaire groep met penumbrae. Groep is kleiner dan 2.5°",
            WijzigGegevens:"OPSLAAN",
            WijzigWachtwoord:"Wijzig wachtwoord",
            WitLicht:"Wit licht",
            Wolfgetal: "Wolfgetal",
            WolfHulpInleiding:"Vlekkengroepen op de zon komen voor in twee soorten groepen voor: unipolair en bipolair. In een groep komen donkere umbrae of vlekken voor met mogelijk ook de lichtere penumbrae.",
            WolfgetalSelectieKnop:"Invoer Wolf",
            WH1:"Om de activiteit te bepalen moeten het aantal groepen geteld worden en het aantal umbrae binnen die groep. \n" +
                "g = groepen (N = noordelijk halfrond zon, S = zuidelijk halfrond)\n" +
                "f = vlekken in de groepen (N = noordelijk halfrond zon, S = zuidelijk halfrond)\n" +
                "r = activiteitgetal of Wolfgetal = 10*g + f    (N = noordelijk halfrond zon, S = zuidelijk halfrond)\n",
            WH2:"Unipolaire groepen zijn kleine groepen zonder bipolaire structuur. Ook in unipolaire groepen kunnen penumbrae voorkomen. Voor een unipolaire groep telt g = 1 en f = aantal umbrae in die groep. Een enkele vlek telt als een groep en een vlek!",
            WH3:"Bipolaire groepen vertonen twee delen net als de polen van een magneet (wat ook zo is). Voor een bipolaire groep telt g= 1 en f = aantal umbrae in die groep.",
            WH4:"g = 1, f = 1",
            WH5:"g = 1, f = 4",
            WH6:"g = 1, f = 7",
            WH7:"g = 1, f = 11",
            WH8:"g = 1, f = 128",
            WHT1:"Activiteit Zon",
            WHT2:"Unipolaire groep",
            WHT3:"Bipolaire groepen",
            WHT4:"Voorbeeld enkele vlek zonder penumbrae",
            WHT5:"Voorbeeld enkele vlek met penumbrae",
            WHT6:"Voorbeeld bipolaire groep zonder penumbrae",
            WHT7:"Voorbeeld bipolaire groep met penumbrae",
            WHT8:"Voorbeeld zeer grote bipolaire groep (Foto: NASA)",
            WolfNoord:"Wolfgetal noord Rn",
            WolfTotaal:"Wolfgetal R",
            WolfgetalVan:"Wolfgetal van ",
            WolfZuid:"Wolfgetal zuid Rn",
            Zuid:"Zuid",
            greeting: "Hallo",
        };
    }

    setLanguage(lang) {
        this.state.language = lang;
        localStorage.setItem("language", lang);
    }

    getLanguage() {
        return this.state.language;
    }
}